import React from 'react';

export const camelToHyphenated = (str: string) => {
    return str
        .replace(/([a-z0-9])([A-Z])/g, '$1-$2') // match boundary between a lowercase or digit and an uppercase
        .toLowerCase();
};

/**
 * Recursively converts all values in the object to add `px` if the object's key matches the path.
 *
 * @param path The path to the key in the object to convert to px.
 * @param sec The object to convert.
 */
export function convertToPx(path: string, sec: any) {
    for (const k in sec) {
        if (k === path) {
            sec[k] = `${sec[k]}px`;
            continue;
        }
        if (typeof sec[k] === 'object' && Object.keys(sec[k]).length > 0) {
            convertToPx(path, sec[k]);
        }
    }
}

/**
 * @param timestamp_in_s - UNIX timestamp in seconds
 * @return year (e.g. 2021), month (e.g., August), day (e.g., 20), and the timestamp in milliseconds.
 */
export const getDate = (timestamp_in_s: number): {year: number; month: string; day: number; timestamp: number} => {
    const date = new Date(timestamp_in_s * 1000);
    const year = date.getFullYear();
    const month = date.toLocaleString('default', {month: 'long'});
    const day = date.getDate();
    const timestamp = date.getTime();
    return {year, month, day, timestamp};
};

export const executeWithoutPropagation = (event: React.MouseEvent<HTMLElement>, callback: any): void => {
    event.stopPropagation();
    callback();
};
